// 9fbef606107a605d69c0edbcd8029e5d

const placeCard = 'place-card-small';
const placeCardPJP = 'place-card-pjp-small';
const giftCard = 'gift-card-small';

const cardIconMapping = {
  DISC: 'disc-small',
  DISCOVER: 'disc-small',
  MC: 'mc-small',
  'MASTER CARD': 'mc-small',
  Amex: 'amex-small',
  Visa: 'visa-small',
  GC: giftCard,
  GIFTCARD: giftCard,
  'GIFT CARD': giftCard,
  'PLACE CARD': placeCard,
  'PLACE CARD_PJP': placeCardPJP,
  PLACECARD: placeCard,
  PLACECARD_PJP: placeCardPJP,
  'MY PLACE REWARDS CREDIT CARD': placeCard,
  'MY PLACE REWARDS CREDIT CARD_PJP': placeCardPJP,
  'MY PLACE REWARDS CREDIT CARD PJP': placeCardPJP,
  VENMO: 'venmo-blue-acceptance-mark',
  VISA: 'visa-small',
  AFTERPAY: 'after-pay-icon',
  'CASHAPP-AFTERPAY': 'cashapp-afterpay-logo-white',
  AMEX: 'amex-small',
  paypal: 'paypal-icon',
  PAYPAL: 'paypal-icon',
  'APPLE PAY': 'apple-pay-icon',
  applepay: 'applepay-small',
  APPLEPAY: 'apple-pay-icon',
  afterpay: 'after-pay-icon',
  visaSPC: 'visa-small-spc',
  discSPC: 'discover-small-spc',
  discoverSPC: 'discover-small-spc',
  amexSPC: 'amex-small-spc',
  mcSPC: 'mastercard-small-spc',
  mastercardSPC: 'mastercard-small-spc',
  paypalSPC: 'paypal-small-spc',
  placecardSPC: 'elements-plcc-card',
  'place cardSPC': 'elements-plcc-card',
};

export default cardIconMapping;
